import { Exception } from '../../../../core/logic/exception';

export class SurveyNotFoundException extends Exception<never> {
  constructor() {
    super('Questionnaire non trouvé');
  }
}
